/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
//@ts-ignore
import { REACT_APP_BOOTSTRAP } from '@env';
import axios from 'axios';

import { LoggerModule } from '@vlinder-web/logger-module-react';

import { VApplication } from './application';
import { FONTS, IMAGES } from './assets';
import { BootstrapApp } from './bootstrap';
import { useAppLoader, useConstructor } from './providers';
import { StorageModule } from '@vlinder-web/storage-module-react';

const MODULE_NAME = 'App';
const log: any = LoggerModule?.getInstance({
  visible: false,
});


const is = require('is_js');
const _bootstrapHandler = async () => {
  await bootstrap();
  const vapp = VApplication.getInstance();
  
  await vapp.start();
  log?.success(MODULE_NAME, `🚀 Main Application Started 🚀`);
////
  //Do other config here !! Example: Sentry Initialization !!
};

const bootstrap = async () => {
  try {
    const storageService = StorageModule.getInstance();
    if (is.existy(storageService.get('appConfig', 'session'))) {
      console.log('storage session exist');
      return;
    } else if (REACT_APP_BOOTSTRAP) {
      console.log('react app bootstrap', REACT_APP_BOOTSTRAP);
      const kv = await axios.get(REACT_APP_BOOTSTRAP);
      if (kv?.data) {
        console.log('storageService data=>', kv?.data);
        storageService.set('appConfig', kv.data, 'session');
      }
    }
  } catch (err: any) {
    console.log('error in bootstrap', err?.message);
    throw Error(`error in bootstrap ${err?.message}`);
  }
};


export const App = () => {
  const [bootstrap, setbootstrap] = useState<boolean>(false);
  useConstructor(_bootstrapHandler)
    .then((res) => {
      log.info(`bootstrap check`, res);
      setbootstrap(true);
    })
    .catch((err) => {
      log.error(`error in bootstrap  ${err.message}`);
      setbootstrap(true);
    });
  const { AppLoading, setReady, isReady, cacheResource } = useAppLoader({
    fonts: FONTS,
    assets: [...(IMAGES || [])],
  });

  

  
  if (!isReady && AppLoading) {
    return (
      <AppLoading
        startAsync={cacheResource}
        onFinish={() => setReady(true)}
        onError={log?.warn}
      />
    );
  }
  if (bootstrap) {
    return <BootstrapApp />;
  }
  return <div />;
};
